<template>
    <div class="orderContent">
        <div class="orderTopTitle">我的订单</div>
        <el-tabs v-model="active" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in tabData" :key="index" :label="item" :name="String(index)"></el-tab-pane>
        </el-tabs>
        <div class="searchBox align">
            <div class="searchTitle">类型</div>
            <el-select v-model="value" clearable placeholder="服务类型" size="large" class="orderSearch" @change="selChange">
                <el-option v-for="(item,ii) in array" :key="ii" :label="item" :value="item" />
            </el-select>
            <el-input v-model="keyWord" placeholder="请输入订单编号/关键字" class="orderSearch"></el-input>
            <el-button type="primary" class="searchBtn" @click="getReset">搜索</el-button>
        </div>
        <div class="orderTr flex">
            <div style="width: 10%">商品</div>
            <div style="width: 20%">名称</div>
            <div style="width: 12%">规格</div>
            <div style="width: 13%">订单编号</div>
            <div style="width: 10%">价格</div>
            <div style="width: 10%">交易状态</div>
        </div>
        <div class="orderList">
            <div class="orderBox" v-for="(item,index) in orderListData.list" :key="index">
                <div class="orderTop align" @click="getGoodsDetail(item.url)">
                    <el-image :src="require('@/assets/icon/orderLogo.png')" fit="cover" class="orderLogo"></el-image>
                    <div class="storeName">{{ item.goods_name }}</div>
                    <el-image :src="require('@/assets/icon/nextGrey.png')" fit="cover" class="orderNext"></el-image>
                    <div class="orderTime">{{ item.create_time }}</div>
                </div>
                <div class="orderTh align">
                    <div style="width: 10%">
                        <el-image :src="item.goods_img" fit="cover" class="orderImg"></el-image>
                    </div>
                    <div style="width: 20%" class="center">
                        <div class="orderTd">{{ item.goods_name }}</div>
                    </div>
                    <div style="width: 12%" class="center">
                        <div class="orderTd">{{ item.spec_name }}</div>
                    </div>
                    <div style="width: 13%" class="center">
                        <div class="orderTd">{{ item.order_num }}</div>
                    </div>
                    <div style="width: 10%" class="center">
                        <div class="orderTd"> 实付款￥{{ item.total_price }}</div>
                    </div>
                    <div style="width: 10%" class="center">
                        <div class="orderTd">{{ item.status_zh }}</div>
                    </div>
                    <div style="width: 15%" class="orderBtn center" @click="orderBtnTap(item.order_num)">订单详情</div>
                </div>
            </div>
        </div>
        <div class="pageBox">
            <el-pagination background layout="prev, pager, next" :page-size="20" :total="orderListData.count" @current-change="currentPage"></el-pagination>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                userDetail: 0,
                tabData: ['全部','交付中','交付完成','退款/售后'],
                active: '0',
                array: ['视频号功能','视频号服务','视频号选品库'],
				index: 0,
                value: '',
                keyWord: '',
                page: 1,
                orderListData: {}
            }
        },
        created(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getorderList()
        },
        methods: {
            // 获取订单列表
            getorderList(){
                this.request.get("index/user/order",{
                    params:{
                        userid: this.userDetail.userid,
                        keyword: this.keyWord,
                        status: this.active,
                        type: this.index,
                        page: this.page,
                        pagesize: 20,
                        dif: 1
                    }
                })
                .then(res=>{
                    this.orderListData = res.data
                })
            },
            // 列表重置封装
            getReset(){
				this.page = 1
				this.getorderList()
			},
            // table切换
            handleClick(tab, event) {
                this.active = tab.name
                this.getReset()
            },
            // 下拉选项
            selChange(e){
                this.array.map((el,i) => {
                    if(el == e){
                        this.index = i + 1
                    }
                })
                if(e == ''){
                    this.index = 0
                }
                this.getReset()
            },
             // 翻页
             currentPage(e){
                this.page = e
                this.getorderList()
            },
            // 跳转订单详情
            orderBtnTap(e){
                this.$router.push({ query:{type: 'orderDetail',id : e} })
            },
            // 跳转商品详情
            getGoodsDetail(e){
                this.$router.push({ path: e })
            }
        }
    }
</script>
<style lang="less" scoped>
    .orderContent{
        width: 100%;
        .orderTopTitle{
            font: 20px/60px "Microsoft YaHei";
            color: #606263;
        }
        .searchBox{
            .searchTitle{
                font: 14px/14px "Microsoft YaHei";
                color: #606263;
                margin-right: 10px;
            }
            .orderSearch{
                width: 214px;
                margin-right: 21px;
            }
            .searchBtn{
                width: 120px;
                background: #FF6A00;
                border-radius: 3px;
            }
        }
        .orderTr{
            width: 100%;
            height: 30px;
            background: #F3F4F8;
            font: 14px/30px "Microsoft YaHei";
            color: #606263;
            text-align: center;
            margin-top: 20px;
        }
        .orderList{
            width: 100%;
            height: calc(100vh - 360px);
            overflow-y: scroll;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            .orderBox{
                width: 100%;
                margin-top: 30px;
                border-bottom: 2px solid #EFF1F5;
                font: 14px/26px "Microsoft YaHei";
                color: #606263;
                
                .orderTop{
                    width: 100%;
                    padding: 0 14px;
                    height: 30px;
                    background: #FAFAFA;
                    border-bottom: 2px solid #EFF1F5;
                    cursor: pointer;
                    .orderLogo{
                        width: 19px;
                        height: 17px;
                    }
                    .storeName{
                        padding: 0 7px;
                    }
                    .orderNext{
                        width: 6px;
                        height: 12px;
                    }
                    .orderTime{
                        padding-left: 20px;
                    }
                }
                .orderTh{
                    width: 100%;
                    padding: 20px 0;
                    .orderTd{
                        max-height: 52px;
                        padding: 0 10px;
                        -webkit-line-clamp: 2;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
                        word-break: break-all;
                    }
                    .orderImg{
                        width: 62px;
                        height: 62px;
                        border-radius: 3px;
                        margin: 0 20px;
                    }
                    .orderBtn{
                        color: #FF6A00;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>